<template>
	<div class="o-wrap">
		<el-page-header @back="$router.go(-1)" content="编辑参展公司" />
		<Exhibitor :fenqu="fenqu" :newsForm="form" @eventForm="handleGetForm" />
	</div>
</template>

<script>
	import Axios from 'axios'
	import Exhibitor from '@/components/Exhibitor/Form'
	export default {
		data() {
			return {
				form: {},
				ids:'',
				zhid:'',
				fenqu:[]
			}
		},
		created() {
			this.ids = this.$route.query.zhid
			this.zhid = this.$route.query.id
			Axios.post('Exhibition-Admin-getExhibitorSignUpInfo',  this.$qs.stringify({
				type: 1,
				exhibition_id: this.$route.query.id,
				user_id: this.$store.state.USER_ID,
				id:this.$route.query.zhid
			})).then(data => {
				this.form = data.data.data
				let list = []
				data.data.fenqu.map((item) => {
					list.push({
						"name": item,
						"value": item
					})
				})
				this.fenqu = list
			})
		},
		methods: {
			handleGetForm(form) {
				form.exhibition_id = this.$route.query.id
				form.id = this.$route.query.zhid
				this.$axios.post('Exhibition-Admin-addSaveExhibitionCompanyInfo', form).then(data => {
					this.$message.success('修改成功');
					this.$router.push('/exhibitor?id='+this.$route.query.id)
				})
			}
		},
		components: {
			Exhibitor
		}
	}
</script>

<style>
</style>
